import React, { useState } from "react";
import { findBankLogo } from "../../../../features/profile/components/bank-selector-field.utils";
import { getShebaInfo } from "@persian-tools/persian-tools";
import { Box } from "@mui/material";

type BankLogoProps = {
  bankName?: string;
  pspName?: string;
  iban?: string;
  iconSize?: string;
};

export function BankLogo({
  bankName,
  pspName,
  iban,
  iconSize,
}: BankLogoProps): JSX.Element {
  const [imageError, setImageError] = useState(false);

  let logo = "";

  if (iban) {
    const sheba = getShebaInfo(iban);
    if (sheba) bankName = sheba?.persianName + "";
  }

  if (bankName) logo = findBankLogo(bankName);

  return (
    <>
      {logo && !imageError ? (
        <Box
          sx={{
            width: iconSize ? iconSize : "24px",
            height: iconSize ? iconSize : "24px",
            marginRight: "7px",
          }}
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              transform: "translate(0px,-1px)",
            }}
            src={logo}
            alt="لوگو بانک"
            onError={() => setImageError(true)}
          />
        </Box>
      ) : (
        <i
          className="fa-regular fa-university"
          style={{
            fontSize: "20px",
            transform: "translate(-2px,0px)",
            paddingLeft: "10px",
          }}
        />
      )}
    </>
  );
}
